const regexPattern = /^[0-9]{4}$/;
// Must be a number and have 4 digits
export const validatePostnr = (postnr: string) => regexPattern.test(postnr);
